import React from "react";
import { Card, FormGroup } from "@mui/material";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import { useTranslation } from "react-i18next";

const FormPratica = ({ practice }) => {
  const { t } = useTranslation();
  return (
    <Card className="p-5 rounded-xl">
      <FormGroup className="w-full">
        <CoreInputField
          label={t("Name")}
          name="Name"
          value={practice?.userName}
          disabled
        />
      </FormGroup>
      <FormGroup className="w-full">
        <CoreInputField
          label={t("CF")}
          name="FiscalCode"
          value={practice?.fiscalCodeUser}
          disabled
        />
      </FormGroup>

      <FormGroup className="w-full">
        <CoreInputField
          label="Email"
          name="Email"
          value={practice?.email}
          disabled
        />
      </FormGroup>

      <FormGroup className="w-full">
        <CoreInputField
          label={t("Operator")}
          name="CommDisplayName"
          value={practice?.commDisplayName}
          disabled
        />
      </FormGroup>
    </Card>
  );
};

export default FormPratica;
